var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('dt',{staticClass:"text-sm font-medium text-gray-500"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('dd',{staticClass:"mt-1 text-sm text-gray-900"},[_vm._v(" "+_vm._s(_vm.formatDate ? _vm.doFormatDate(_vm.value) : _vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }